import { useCallback, useMemo } from 'react';
import SsoLoginDao from '../data/SsoLoginDao';
import { useRedirect } from './useRedirect';
import { returnLoginRedirectOrChatspotRedirect } from '../utils/urls';
import { FAILED_LOGIN_PAGES } from '../constants/FailedLoginPages';
import { useHistory } from 'react-router-dom';
import { stringify } from 'hub-http/helpers/params';
const ssoLoginDao = new SsoLoginDao();
export const useSsoLogin = ({
  email,
  loginPortalId,
  loginRedirectUrl,
  handleError,
  rememberLogin
}) => {
  const history = useHistory();
  const {
    redirectToUrl
  } = useRedirect({
    email,
    loginPortalId,
    loginRedirectUrl
  });
  const handleErrorOrRedirect = useCallback(responseJSON => {
    if (responseJSON && responseJSON.status) {
      if (responseJSON.status in FAILED_LOGIN_PAGES) {
        const nextPath = `${FAILED_LOGIN_PAGES[responseJSON.status]}?${stringify({
          email: responseJSON.errorTokens.email[0]
        })}`;
        history.push(nextPath);
      } else if (handleError) {
        handleError(responseJSON.status);
      }
    } else if (handleError) {
      handleError('LOGIN_UNAVAILABLE');
    }
  }, [history, handleError]);
  const loginWithSso = useCallback(() => {
    ssoLoginDao.startLogin({
      email,
      loginPortalId,
      loginRedirectUrl: returnLoginRedirectOrChatspotRedirect(loginRedirectUrl, loginPortalId),
      rememberLogin
    }).then(response => {
      redirectToUrl(response.redirectUrl);
    }).catch(({
      responseJson
    }) => handleErrorOrRedirect(responseJson));
  }, [email, loginPortalId, loginRedirectUrl, handleErrorOrRedirect, redirectToUrl, rememberLogin]);
  return useMemo(() => ({
    loginWithSso
  }), [loginWithSso]);
};